/**
 * API Configuration
 * 
 * Update the API_BASE_URL based on your environment
 */

// Auto-detect production vs development
const getApiBaseUrl = () => {
  // Check if we're in production (hosted domain)
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Production domain
    if (hostname === 'blogs.360coordinates.com' || hostname.includes('360coordinates.com')) {
      return 'https://blogs.360coordinates.com/backend/api';
    }
    
    // Local dev: proxy /backend → blogs.360coordinates.com (see setupProxy.js)
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return process.env.REACT_APP_API_URL || '/backend/api';
    }
  }

  // Fallback: env override, then production API
  return (
    process.env.REACT_APP_API_URL ||
    'https://blogs.360coordinates.com/backend/api'
  );
};

export const API_BASE_URL = getApiBaseUrl();

/** Send session cookies when API is same-origin (localhost proxy or production deploy). */
export const shouldUseApiCredentials = () => {
  if (typeof window === 'undefined') return false
  try {
    const apiOrigin = API_BASE_URL.startsWith('/')
      ? window.location.origin
      : new URL(API_BASE_URL).origin
    return apiOrigin === window.location.origin
  } catch {
    return false
  }
}

export default {
  baseURL: API_BASE_URL,
  timeout: 10000, // 10 seconds
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: shouldUseApiCredentials(),
};
